import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { useFormik } from 'formik';
import { Grid, Typography } from '@material-ui/core';
import Select from '../../../../../../components/Select';
import Input from '../../../../../../components/Input';
import Button from '../../../../../../components/Button';

import { updateRegime } from '../../../../store/thunk';

import { useStyles } from './styles';

const binaryOptions = [
  { value: '1', label: 'Sim' },
  { value: '0', label: 'Não' }
];

const activatedOptions = [
  { value: 0, label: 'Desativado' },
  { value: 1, label: 'Ativado' }
];

export default function Restrictions() {
  const dispatch = useDispatch();

  const styles = useStyles();

  const { userId } = useSelector(state => state.profile);

  const {
    isRestrictionsLoading,
    restrictions,
    custom_settings,
    isRpsConfig,
    basicInfo: {
      cityCode
    }
  } = useSelector(state => state.provisionalReceiptConfig);

  const {
    requiredNbsCode,
    requiredIbscbsCode,
    requiredIbscbsCctCode,
    requiredSchemaVersion,
    percentualEstadual,
    percentualMunicipal,
    percentualCbs,
    nationalAttachment,
    nationalAliquot
  } = custom_settings || {};

  const handleSubmit = values => {
    delete values['restrictionsCheckbox'];
    delete values['sequence'];

    return dispatch(updateRegime(userId, cityCode, values));
  }

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      ...restrictions,
      requiredNbsCode,
      requiredIbscbsCode,
      requiredIbscbsCctCode,
      requiredSchemaVersion,
      percentualEstadual,
      percentualMunicipal,
      percentualCbs,
      nationalAttachment,
      nationalAliquot,
      restrictionsCheckbox: isRpsConfig
    },
    onSubmit: values => handleSubmit(values)
  });

  return(
    <form onSubmit={event => event.preventDefault()}>
      <Grid container>
        <Grid item xs={12} style={{ display: 'flex', gap: 20, alignItems: 'center', marginTop: 30, marginBottom: 20, paddingBottom: 10, borderBottom: '1px solid #E4E7EA' }}>
          <Typography color="primary">
            <b>Restrições de envio de NFS-e de cada prefeitura</b>
          </Typography>
          <Button
            disabled={!cityCode}
            loading={isRestrictionsLoading}
            type='button'
            color='success'
            onClick={formik.handleSubmit}
          >
            Salvar
          </Button>
        </Grid>
        <Grid item xs={12} md={6}>
          <Typography variant="h6" color="primary" className={styles.text}>
            <b>Cliente/Tomador:</b>
          </Typography>
          <Grid container>
            <Grid xs={8} style={{ display: 'flex', alignItems: 'center' }}>
              <Typography variant="h6" color="primary" className={styles.text}>
                Obrigatoriedade no cadastro de cliente:
              </Typography>
            </Grid>
            <Grid xs={3}>
              <Select
                name="requiredClient"
                options={binaryOptions}
                value={formik.values.requiredClient?.toString()}
                onChange={formik.handleChange}
              />
            </Grid>
          </Grid>
          <Grid container>
            <Grid xs={8} style={{ display: 'flex', alignItems: 'center' }}>
              <Typography variant="h6" color="primary" className={styles.text}>
                Obrigatoriedade no nome:
              </Typography>
            </Grid>
            <Grid xs={3}>
              <Select
                disabled={+formik.values.requiredClient == 0}
                name="requiredClientName"
                options={binaryOptions}
                value={formik.values.requiredClientName?.toString()}
                onChange={formik.handleChange}
              />
            </Grid>
            <Grid xs={12} style={{ display: 'flex', flexDirection: 'row' }}>
              <Grid container>
                <Grid xs={2} style={{ display: 'flex', alignItems: 'center' }}>
                  <Typography variant="h6" color="primary" className={styles.text}>
                    Preencher
                  </Typography>
                </Grid>
                <Grid xs={4}>
                  <Input
                    disabled={+formik.values.requiredClient == 0}
                    name="clientNameDefault"
                    type="text"
                    value={formik.values.clientNameDefault}
                    onChange={formik.handleChange}
                  />
                </Grid>
                <Grid xs={4} style={{ display: 'flex', alignItems: 'center' }}>
                  <Typography variant="h6" color="primary" className={styles.text} style={{ marginLeft: 10 }}>
                    caso campo vazio
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <Grid container>
            <Grid xs={8} style={{ display: 'flex', alignItems: 'center' }}>
              <Typography variant="h6" color="primary" className={styles.text}>
                Obrigatoriedade no CPF/CNPJ:
              </Typography>
            </Grid>
            <Grid xs={3}>
              <Select
                disabled={+formik.values.requiredClient == 0}
                name="requiredClientDocumentId"
                options={binaryOptions}
                value={formik.values.requiredClientDocumentId?.toString()}
                onChange={formik.handleChange}
              />
            </Grid>
            <Grid xs={12} style={{ display: 'flex', flexDirection: 'row' }}>
              <Grid container>
                <Grid xs={2} style={{ display: 'flex', alignItems: 'center' }}>
                  <Typography variant="h6" color="primary" className={styles.text}>
                    Preencher
                  </Typography>
                </Grid>
                <Grid xs={4}>
                  <Input
                    disabled={+formik.values.requiredClient == 0}
                    name="clientDocumentIdDefault"
                    type="text"
                    value={formik.values.clientDocumentIdDefault}
                    onChange={formik.handleChange}
                  />
                </Grid>
                <Grid xs={4} style={{ display: 'flex', alignItems: 'center' }}>
                  <Typography variant="h6" color="primary" className={styles.text} style={{ marginLeft: 10 }}>
                    caso campo vazio
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <Grid container>
            <Grid xs={8} style={{ display: 'flex', alignItems: 'center' }}>
              <Typography variant="h6" color="primary" className={styles.text}>
                Obrigatoriedade no endereço do cliente:
              </Typography>
            </Grid>
            <Grid xs={3}>
              <Select
                disabled={+formik.values.requiredClient == 0}
                name="requiredClientAddress"
                options={binaryOptions}
                value={formik.values.requiredClientAddress?.toString()}
                onChange={formik.handleChange}
              />
            </Grid>
            <Grid xs={12} style={{ display: 'flex', flexDirection: 'row' }}>
              <Grid container>
                <Grid xs={2} style={{ display: 'flex', alignItems: 'center' }}>
                  <Typography variant="h6" color="primary" className={styles.text}>
                    Preencher
                  </Typography>
                </Grid>
                <Grid xs={4}>
                  <Input
                    disabled={+formik.values.requiredClient == 0}
                    name="clientAddressDefault"
                    type="text"
                    value={formik.values.clientAddressDefault}
                    onChange={formik.handleChange}
                  />
                </Grid>
                <Grid xs={4} style={{ display: 'flex', alignItems: 'center' }}>
                  <Typography variant="h6" color="primary" className={styles.text} style={{ marginLeft: 10 }}>
                    caso campo vazio
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} md={6}>
          <Typography variant="h6" color="primary" className={styles.text}>
            <b>Empresa:</b>
          </Typography>
          <Grid container>
            <Grid xs={8} style={{ display: 'flex', alignItems: 'center' }}>
              <Typography variant="h6" color="primary" className={styles.text}>
                CNAE:
              </Typography>
            </Grid>
            <Grid xs={3}>
              <Select
                name="requiredCnae"
                options={binaryOptions}
                value={formik.values.requiredCnae?.toString()}
                onChange={formik.handleChange}
              />
            </Grid>
          </Grid>
          <Grid container>
            <Grid xs={8} style={{ display: 'flex', alignItems: 'center' }}>
              <Typography variant="h6" color="primary" className={styles.text}>
                Código Serviço:
              </Typography>
            </Grid>
            <Grid xs={3}>
              <Select
                name="requiredMunicipalServiceCode"
                options={binaryOptions}
                value={formik.values.requiredMunicipalServiceCode?.toString()}
                onChange={formik.handleChange}
              />
            </Grid>
          </Grid>
          <Grid container>
            <Grid xs={8} style={{ display: 'flex', alignItems: 'center' }}>
              <Typography variant="h6" color="primary" className={styles.text}>
                Código Item Lista Serviço:
              </Typography>
            </Grid>
            <Grid xs={3}>
              <Select
                name="requiredServiceItem"
                options={binaryOptions}
                value={formik.values.requiredServiceItem?.toString()}
                onChange={formik.handleChange}
              />
            </Grid>
          </Grid>
          <Grid container>
            <Grid xs={8} style={{ display: 'flex', alignItems: 'center' }}>
              <Typography variant="h6" color="primary" className={styles.text}>
                Natureza de Tributação:
              </Typography>
            </Grid>
            <Grid xs={3}>
              <Select
                name="taxationNature"
                options={binaryOptions}
                value={formik.values.taxationNature?.toString()}
                onChange={formik.handleChange}
              />
            </Grid>
          </Grid>
          <Grid container>
            <Grid xs={8} style={{ display: 'flex', alignItems: 'center' }}>
              <Typography variant="h6" color="primary" className={styles.text}>
                Código NBS:
              </Typography>
            </Grid>
            <Grid xs={3}>
              <Select
                label='Código NBS'
                name='requiredNbsCode'
                value={formik.values.requiredNbsCode}
                options={activatedOptions}
                onChange={formik.handleChange}
              />
            </Grid>
          </Grid>
          <Grid container>
            <Grid xs={8} style={{ display: 'flex', alignItems: 'center' }}>
              <Typography variant="h6" color="primary" className={styles.text}>
                Código IBSCBS:
              </Typography>
            </Grid>
            <Grid xs={3}>
              <Select
                label='Código IBSCBS'
                name='requiredIbscbsCode'
                value={formik.values.requiredIbscbsCode}
                options={activatedOptions}
                onChange={formik.handleChange}
              />
            </Grid>
          </Grid>
          <Grid container>
            <Grid xs={8} style={{ display: 'flex', alignItems: 'center' }}>
              <Typography variant="h6" color="primary" className={styles.text}>
                Código IBSCBS CCT:
              </Typography>
            </Grid>
            <Grid xs={3}>
              <Select
                label='Código IBSCBS CCT'
                name='requiredIbscbsCctCode'
                value={formik.values.requiredIbscbsCctCode}
                options={activatedOptions}
                onChange={formik.handleChange}
              />
            </Grid>
          </Grid>
          <Grid container>
            <Grid xs={8} style={{ display: 'flex', alignItems: 'center' }}>
              <Typography variant="h6" color="primary" className={styles.text}>
                Versão Esquema:
              </Typography>
            </Grid>
            <Grid xs={3}>
              <Select
                label='Versão Esquema'
                name='requiredSchemaVersion'
                value={formik.values.requiredSchemaVersion}
                options={activatedOptions}
                onChange={formik.handleChange}
              />
            </Grid>
          </Grid>
          <Grid container>
            <Grid xs={8} style={{ display: 'flex', alignItems: 'center' }}>
              <Typography variant="h6" color="primary" className={styles.text}>
                Finalidade NFSe:
              </Typography>
            </Grid>
            <Grid xs={3}>
              <Select
                label='Finalidade NFSe'
                name='nfsePurpose'
                value={formik.values.nfsePurpose}
                options={activatedOptions}
                onChange={formik.handleChange}
              />
            </Grid>
          </Grid>
          <Grid container>
            <Grid xs={8} style={{ display: 'flex', alignItems: 'center' }}>
              <Typography variant="h6" color="primary" className={styles.text}>
                Percentual Estadual:
              </Typography>
            </Grid>
            <Grid xs={3}>
              <Select
                label='Percentual Estadual'
                name='percentualEstadual'
                value={formik.values.percentualEstadual}
                options={activatedOptions}
                onChange={formik.handleChange}
              />
            </Grid>
          </Grid>
          <Grid container>
            <Grid xs={8} style={{ display: 'flex', alignItems: 'center' }}>
              <Typography variant="h6" color="primary" className={styles.text}>
                Percentual Municipal:
              </Typography>
            </Grid>
            <Grid xs={3}>
              <Select
                label='Percentual Municipal'
                name='percentualMunicipal'
                value={formik.values.percentualMunicipal}
                options={activatedOptions}
                onChange={formik.handleChange}
              />
            </Grid>
          </Grid>
          <Grid container>
            <Grid xs={8} style={{ display: 'flex', alignItems: 'center' }}>
              <Typography variant="h6" color="primary" className={styles.text}>
                Percentual CBS:
              </Typography>
            </Grid>
            <Grid xs={3}>
              <Select
                label='Percentual CBS'
                name='percentualCbs'
                value={formik.values.percentualCbs}
                options={activatedOptions}
                onChange={formik.handleChange}
              />
            </Grid>
          </Grid>
          <Grid container>
            <Grid xs={8} style={{ display: 'flex', alignItems: 'center' }}>
              <Typography variant="h6" color="primary" className={styles.text}>
                Anexo Simples Nacional:
              </Typography>
            </Grid>
            <Grid xs={3}>
              <Select
                label='Anexo Simples Nacional'
                name='nationalAttachment'
                value={formik.values.nationalAttachment}
                options={activatedOptions}
                onChange={formik.handleChange}
              />
            </Grid>
          </Grid>
          <Grid container>
            <Grid xs={8} style={{ display: 'flex', alignItems: 'center' }}>
              <Typography variant="h6" color="primary" className={styles.text}>
                Alíquota Simples Nacional:
              </Typography>
            </Grid>
            <Grid xs={3}>
              <Select
                label='Alíquota Simples Nacional'
                name='nationalAliquot'
                value={formik.values.nationalAliquot}
                options={activatedOptions}
                onChange={formik.handleChange}
              />
            </Grid>
          </Grid>
          <br />
          <Typography variant="h6" color="primary" className={styles.text}>
            <b>Cancelamento de NFS-e:</b>
          </Typography>
          <Grid container>
            <Grid xs={8} style={{ display: 'flex', alignItems: 'center' }}>
              <Typography variant="h6" color="primary" className={styles.text}>
                Cancelamento NF-e precisa do cadastro de cliente:
              </Typography>
            </Grid>
            <Grid xs={3}>
              <Select
                name="requiredClientToCancel"
                options={binaryOptions}
                value={formik.values.requiredClientToCancel?.toString()}
                onChange={formik.handleChange}
              />
            </Grid>
          </Grid>
          <Grid container>
            <Grid xs={8} style={{ display: 'flex', alignItems: 'center' }}>
              <Typography variant="h6" color="primary" className={styles.text}>
                Cancelamento de NF-e precisa do CPF/CNPJ do cliente:
              </Typography>
            </Grid>
            <Grid xs={3}>
              <Select
                name="requiredClientDocumentIdToCancel"
                options={binaryOptions}
                value={formik.values.requiredClientDocumentIdToCancel?.toString()}
                onChange={formik.handleChange}
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </form>
  );
}